import {UntypedFormGroup} from '@angular/forms';
import {canShowErrorForErrorCodeAndFormControlForFormGroup} from './can-show-error-for-error-code-and-form-control-for-form-group';

export function canShowErrorForErrorCodeAndButtonForFormGroup(errorCode: string, formControlName: string, formGroup: UntypedFormGroup): boolean {
  return canShowErrorForErrorCodeAndFormControlForFormGroup(errorCode, formControlName, formGroup) && formGroup.get(formControlName).touched;
}
